import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useBossBabyChatLogStore } from "@/store/useBossBabyChatLogStore";

/**
 * Boss Baby 세션 상세 페이지 훅
 *
 * @description Boss Baby 세션 상세 페이지의 상태와 로직을 관리하는 커스텀 훅
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
export const useSessionDetail = () => {
  const { sessionUuid } = useParams<{ sessionUuid: string }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<number>(0);

  const { currentSession, messages, loading, fetchSessionMessages } =
    useBossBabyChatLogStore();

  useEffect(() => {
    if (sessionUuid) {
      fetchSessionMessages(sessionUuid);
    }
  }, [sessionUuid, fetchSessionMessages]);

  const handleBack = () => {
    navigate("/boss-baby-chat-log/sessions");
  };

  // 탭 변경 핸들러
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return {
    // 상태
    sessionUuid,
    currentSession,
    messages,
    loading,
    activeTab,

    // 핸들러
    handleBack,
    handleTabChange,
  };
};